import { render } from "./ContentKredit.vue?vue&type=template&id=6ee3dc20&scoped=true"
import script from "./ContentKredit.vue?vue&type=script&lang=js"
export * from "./ContentKredit.vue?vue&type=script&lang=js"

import "./ContentKredit.vue?vue&type=style&index=0&id=6ee3dc20&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee3dc20"]])

export default __exports__